import { SiteViewerPage } from '@/features/public-sites/site-viewer-page';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
export const Route = createFileRoute('/_authed/website-preview')({
  validateSearch: z.object({
    locationId: z.string().min(1).max(100),
    versionId: z.uuid(),
    style: z.enum(['editorial', 'luxury', 'studio', 'signature']).optional(),
    background: z
      .string()
      .regex(/^#[0-9a-fA-F]{6}$/)
      .optional(),
    primary: z
      .string()
      .regex(/^#[0-9a-fA-F]{6}$/)
      .optional(),
    accent: z
      .string()
      .regex(/^#[0-9a-fA-F]{6}$/)
      .optional(),
    spacing: z.enum(['Airy', 'Balanced', 'Compact']).optional(),
  }),
  component: Viewer,
});
function Viewer() {
  return <SiteViewerPage {...Route.useSearch()} />;
}
